export default {
  /**
   * Просмотр продуктового лендинга дольше 3 сек
   * @param {string|number} data.amoId - AMO ID продукта
   * @param {string} data.skbClientId - Внутренний Customer ID сайта. Если не передан, будет подставлен автоматически
   * @param {string} data.url - URL страницы. Если не передан, будет подставлен автоматически
   * @param {string|number} data.discountedPrice - Цена со скидкой
   * @param {string|number} data.fullPrice - Полная цена
   * @param {string|number} data.installmentDuration - Длительность рассрочки
   * @param {string|number} data.monthlyPrice - Платеж по рассрочке
   */
  courseView(data = {}) {
    const {
      amoId,
      skbClientId,
      url,
      discountedPrice,
      fullPrice,
      installmentDuration,
      monthlyPrice
    } = data

    return {
      operation: 'Website.CourseView',
      data: {
        viewProduct: {
          product: {
            ids: {
              skillboxExternalSystem: amoId
            }
          },
          customerAction: {
            customFields: {
              skbClientId,
              url,
              discountedPrice,
              fullPrice,
              installmentDuration,
              monthlyPrice
            }
          }
        }
      }
    }
  },

  /**
   * Заполнение формы заявки на LandGen
   * @param {string|number} data.courseAMOID - ID курса
   * @param {string} data.formName - Название формы
   * @param {string} data.directionName - Название направления
   * @param {number} data.directionId - ID направления
   * @param {string} data.skbClientId - Внутренний Customer ID сайта. Если не передан, будет подставлен автоматически
   * @param {string} data.url - URL страницы. Если не передан, будет подставлен автоматически
   * @param {string|number} data.discountedPrice - Цена со скидкой
   * @param {string|number} data.fullPrice - Полная цена
   * @param {string|number} data.installmentDuration - Длительность рассрочки
   * @param {string|number} data.monthlyPrice - Платеж по рассрочке
   */
  courseApplicationFormStart(data = {}) {
    const {
      courseAMOID,
      formName,
      directionName,
      directionId,
      skbClientId,
      url,
      discountedPrice,
      fullPrice,
      installmentDuration,
      monthlyPrice
    } = data

    return {
      operation: 'Website.CourseApplicationFormStart',
      data: {
        customerAction: {
          customFields: {
            courseAMOID,
            formName,
            directionName,
            directionId,
            discountedPrice,
            fullPrice,
            installmentDuration,
            monthlyPrice,
            skbClientId,
            url
          }
        }
      }
    }
  },

  /**
   * Успешная отправка формы заявки на LandGen
   * @param {string} data.email - Email
   * @param {string|number} data.courseAMOID - ID курса
   * @param {string} data.formName - Название формы
   * @param {string} data.directionName - Название направления
   * @param {number} data.directionId - ID направления
   * @param {string} data.skbClientId - Внутренний Customer ID сайта. Если не передан, будет подставлен автоматически
   * @param {string} data.url - URL страницы. Если не передан, будет подставлен автоматически
   * @param {string|number} data.discountedPrice - Цена со скидкой
   * @param {string|number} data.fullPrice - Полная цена
   * @param {string|number} data.installmentDuration - Длительность рассрочки
   * @param {string|number} data.monthlyPrice - Платеж по рассрочке
   */
  courseApplicationFormComplete(data = {}) {
    const {
      email,
      courseAMOID,
      formName,
      directionName,
      directionId,
      skbClientId,
      url,
      discountedPrice,
      fullPrice,
      installmentDuration,
      monthlyPrice
    } = data

    return {
      operation: 'Website.CourseApplicationFormComplete',
      data: {
        customer: {
          email
        },
        customerAction: {
          customFields: {
            courseAMOID,
            formName,
            directionName,
            directionId,
            discountedPrice,
            fullPrice,
            installmentDuration,
            monthlyPrice,
            skbClientId,
            url
          }
        }
      }
    }
  },

  /**
   * Взаимодействие с формой выбора оплаты на LandGen
   * @param {string} data.email - Email
   * @param {string|number} data.courseAMOID - ID курса
   * @param {string} data.formName - Название формы
   * @param {string} data.directionName - Название направления
   * @param {number} data.directionId - ID направления
   * @param {string} data.skbClientId - Внутренний Customer ID сайта. Если не передан, будет подставлен автоматически
   * @param {string} data.url - URL страницы. Если не передан, будет подставлен автоматически
   */
  coursePaymentFormShow(data = {}) {
    const {
      email,
      courseAMOID,
      formName,
      directionName,
      directionId,
      skbClientId,
      url
    } = data

    return {
      operation: 'Website.CoursePaymentFormShow',
      data: {
        customer: {
          email
        },
        customerAction: {
          customFields: {
            courseAMOID,
            formName,
            directionName,
            directionId,
            skbClientId,
            url
          }
        }
      }
    }
  }
}
